webpackJsonp([264],{

/***/ 1091:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "VUX V2.6.0 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 1906:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1091),
  /* template */
  __webpack_require__(2462),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/v2.6.0-253.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] v2.6.0-253.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e7cf4cde", Component.options)
  } else {
    hotAPI.reload("data-v-e7cf4cde", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2462:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.6.0 发布日志")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/calendar.html"
    }
  }, [_vm._v("Calendar")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持显示弹窗头部(取消，确定)")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/checker.html"
    }
  }, [_vm._v("Checker")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 修复 on-change 事件 在使用 :value 绑定的情况下不触发 #1945")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/datetime.html"
    }
  }, [_vm._v("Datetime")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 修复取消文字、确认文字国际化显示问题")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/grid.html"
    }
  }, [_vm._v("Grid")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[change] rows 属性已经废弃，使用自动计算 #1971")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/inline-calendar.html"
    }
  }, [_vm._v("InlineCalendar")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] (beta) 支持属性 marks 用以自定义特定日期显示样式")]), _vm._v(" "), _c('li', [_vm._v("[fix] 修复星期文字 i18n")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/load-more.html"
    }
  }, [_vm._v("LoadMore")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 修复 `tip` 为空，且 `show-loading` 为 `false` 时背景颜色不对的问题 ")]), _vm._v(" "), _c('li', [_vm._v("[feature] 支持 @load-more-tip-background-color 全局设置文字背景颜色")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/panel.html"
    }
  }, [_vm._v("Panel")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] 支持列表 fallbackSrc 属性在图片加载失败后显示 #1923")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/popup-radio.html"
    }
  }, [_vm._v("PopupRadio")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 修复 placeholder 显示逻辑 #1964")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/swiper.html"
    }
  }, [_vm._v("Swiper")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] 支持 list.fallbackImg 属性在图片加载失败时显示预设图片 #1923")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/x-dialog.html"
    }
  }, [_vm._v("XDialog")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 修复弹窗滑动时 body 区域依然会滚动的问题")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/x-img.html"
    }
  }, [_vm._v("XImg")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 当 src 变化时重新初始化 #1901")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e7cf4cde", module.exports)
  }
}

/***/ }),

/***/ 695:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1906);

/***/ })

});


// WEBPACK FOOTER //
// 264.4359c00a.js